import React, { ComponentProps } from "react";

import CreateSuspendedComponent from "containers/app/CreateSuspendedComponent";

const Component = CreateSuspendedComponent(() => import("./LoginContainer"));

const LoginContainer: React.FC<ComponentProps<typeof Component>> = ({
  ...props
}) => {
  return <Component {...props} />;
};

export default LoginContainer;
